import { isCorpTenant } from "@capone/common";
import fetchCorpUsersList, { CorpUsersListResponse } from "b2b-base/src/api/v1/user/fetchCorpUsersList";
import { buildCorpTravelers } from "b2b-base/src/utils/capone-corporate/travelersMappingUtils";
import {
  CallState,
  CorpSessionInfo,
  ICorpPerson,
  IPerson,
  SessionInfo,
} from "redmond";
import { all, call, put } from "redux-saga/effects";
import { config } from "../../../../api/config";
import { deleteUserPassenger } from "../../../../api/v0/user-passengers/deleteUserPassenger";
import {
  fetchUserPassengers,
  IListUserPassengersResponse,
} from "../../../../api/v0/user-passengers/fetchUserPassengers";
import fetchUserInfo from "../../../../api/v0/user/fetchUserInfo";
import { actions } from "../../actions";

export function* deleteUserPassengerSaga(action: actions.IDeleteUserPassenger) {
  try {
    yield deleteUserPassenger(action.payload);

    const sessionInfo: SessionInfo = yield call(fetchUserInfo);
    const canViewUsers =
      "corporateInfo" in sessionInfo
        ? (sessionInfo as CorpSessionInfo).corporateInfo.permissions
            .canViewUsers
        : false;

    const travelerDefaultTravelerId =
      ("corporateInfo" in sessionInfo &&
        (sessionInfo as CorpSessionInfo).corporateInfo.defaultTravelerId) ??
      "";

    let userPassengers: IPerson[] | ICorpPerson[];
    if (isCorpTenant(config.TENANT)) {
      const [corpUsersList, caponeUserPassengers]: [
        CorpUsersListResponse,
        IListUserPassengersResponse
      ] = yield all([
        canViewUsers
          ? call(fetchCorpUsersList)
          : {
              users: [
                {
                  id: sessionInfo.userId,
                  firstName: sessionInfo.userInfo.firstName,
                  lastName: sessionInfo.userInfo.lastName,
                  defaultTravelerId: travelerDefaultTravelerId,
                },
              ],
            },
        call(fetchUserPassengers, {}),
      ]);

      const hiddenTravelerIds =
        "corporateInfo" in sessionInfo
          ? (sessionInfo as CorpSessionInfo).corporateInfo.hiddenTravelerIds
          : [];

      const loggedInUserId = sessionInfo.userId;

      userPassengers = buildCorpTravelers(
        caponeUserPassengers,
        corpUsersList.users,
        hiddenTravelerIds,
        loggedInUserId
      );
    } else {
      userPassengers = yield fetchUserPassengers({});
    }

    yield put(
      actions.setUserPassengers({
        userPassengerCallState: CallState.Success,
        userPassengers,
      })
    );
  } catch (e) {
    yield put(actions.setUserPassengersCallState(CallState.Failed));
  }
}
